var React = require('react');

function Oval (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(0.000000, -167.000000)"},React.createElement("path",{"fill":"#FFFFFF","d":"M960.5,4722 C2305.58951,4722 3396,3702.32852 3396,2444.5 C3396,1186.67148 2305.58951,167 960.5,167 C-384.589508,167 -1475,1186.67148 -1475,2444.5 C-1475,3702.32852 -384.589508,4722 960.5,4722 Z M963.5,4200 C-71.7577635,4200 -911,3415.37902 -911,2447.5 C-911,1479.62098 -71.7577635,695 963.5,695 C1998.75776,695 2838,1479.62098 2838,2447.5 C2838,3415.37902 1998.75776,4200 963.5,4200 Z"})));
}

Oval.defaultProps = {"viewBox":"0 0 1920 777"};

module.exports = Oval;

Oval.default = Oval;
